/** Browser window helpers (kept here so they can be reused and mocked; jsdom cannot mock window.location directly) */

export const returnToClient = (redirectUrl: string) =>
  window.location.assign(redirectUrl)

/** Leaves the page without keeping it in the history, so Back does not return to it */
export const replaceLocation = (url: string) => window.location.replace(url)

/** Loads the current URL again, its query (e.g. the sign-in's redirect_url) included */
export const reloadPage = () => window.location.reload()

export const getLocationOrigin = () => window.location.origin

export const getLocationSearch = () => window.location.search

/** Whether the page is rendered inside another page, where a click could be made without the user knowing */
export const isFramed = () => window.top !== window.self

/** Leaves the app for another site, keeping this page in the history */
export const goToExternalUrl = (url: string) => window.location.assign(url)

/** window.open features of a popup centered over the browser window */
export const getCenteredPopupFeatures = (width: number, height: number) => {
  const left = Math.round(window.screenX + (window.outerWidth - width) / 2)
  const top = Math.round(window.screenY + (window.outerHeight - height) / 2)

  return `popup,width=${width},height=${height},left=${left},top=${top}`
}
